module.exports = window["core-js/modules/es.array.concat.js"];